'use client'

import { twMerge } from '@/lib/classname/twMerge'
import { cva } from 'class-variance-authority'
import { Cell as AriaCell, composeRenderProps, type CellProps } from 'react-aria-components'
import { useTable } from '../TableContext'

const cellStyles = cva(
  'border-l-px border-r-px border-brand-2-200 p-1 text-brand-2-900 first:border-l-0 last:border-r-0',
  {
    variants: {
      separators: {
        false: 'border-none',
      },
    },
  },
)

export function Cell({ children, className, ...props }: CellProps) {
  const { separators } = useTable()

  return (
    <AriaCell
      {...props}
      className={twMerge(
        cellStyles({ separators }),
        'relative min-w-0 whitespace-normal break-words',
        className,
      )}
    >
      {composeRenderProps(children, (inner) => (
        <>{inner}</>
      ))}
    </AriaCell>
  )
}
